<template>
  <!-- <h1 class="choice-title" :class="{ 'required' : $store.getters?.getQuesInfo?.type === 1 && info?.isRequired }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{ `${quesIndex + 1}、` }}</span>
  </h1> -->
  <div class="choice many_wrap">
    <div class="many-text">
      <template v-for="(item, index) in info.optionVoList" :key="index">
        <h1
          style="margin: 0"
          v-if="index === 0"
          class="choice-title"
          :class="{
            required:
              $store.getters?.getQuesInfo?.type === 1 && info?.isRequired,
          }"
        >
          <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
            `${quesIndex + 1}、`
          }}</span>
        </h1>
        <span>{{ item.content }}</span>
        <input
          :disabled="isReview"
          class="input_many"
          v-model="values[index]"
          @blur="handleInputBlur(item, index)"
        />
        <template v-if="$store.getters.getOrgId !== '225'">
          <span v-if="$store.getters?.isShowType && index === info.optionVoList.length - 1" class="title-tip"
            >（多项填空）</span
          >
        </template>
      </template>
    </div>
    <div v-if="isReview">
      <template class="feedback animate__animated animate__fadeInDown">
        <div v-if="rightType === 0" class="left red">答案：错误</div>
        <div v-if="rightType === 1" class="left green">答案：正确</div>
        <div v-if="rightType === 2" class="left green">答案：部分正确</div>
        <div class="right">正确答案：{{ info?.answer }}</div>
      </template>
      <div v-if="info.explanation" class="explanation">
        <img src="@/assets/img/explanation.png" alt="" />
        <p>解析：{{ info.explanation }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import '../choice/css/choice.scss'
// import { Toast } from 'vant'
import { onMounted, reactive, ref } from 'vue'
import { getAnswer } from '@/utils/tools'

// 输入框改变
const useInputChangeEffect = (props, ctx) => {
  const values = reactive([])
  const answerArr = reactive([])

  if (props.isReview) {
    if (props.info.value) {
      const answerList = JSON.parse(props.info.value)
      answerList.forEach((item) => {
        values[item.orders - 1] = item.content
      })
    }
  }

  const handleInputBlur = (item, index) => {
    if (values[index] === undefined) {

      return false
    }
    const answer = {
      questionKey: props.info.questionKey,
      optionKey: item.optionKey,
      answerContent: values[index],
    }

    const indexs = answerArr.findIndex((v, i) => {
      return v.optionKey === item.optionKey
    })

    if (indexs === -1) {
      answerArr.push(answer)
    } else {
      answerArr[indexs] = answer
    }

    const question = {
      questionKey: props.info.questionKey,
      questionType: props.info.questionType,
      answers: answerArr,
    }
    ctx.emit('inputChange', question)
  }

  onMounted(() => {
    // 做的缓存
    const localAnswer = getAnswer(props.info.questionKey)
    if (localAnswer) {
      localAnswer.map((item, index) => {
        values.push(item.answerContent)
        handleInputBlur(item, index)
      })
    }
  })

  return {
    values,
    handleInputBlur,
  }
}
export default {
  props: ['info', 'quesIndex', 'isReview'],
  emits: ['inputChange'],
  setup(props, ctx) {
    const { values, handleInputBlur } = useInputChangeEffect(props, ctx)

    const rightType = ref(0)

    if (props.info.answer && props.info.value) {
      const valueList = values

      const answerList = props.info.answer.split('#')

      const res = valueList.filter((item) => answerList.includes(item))

      // 1 为全部命中答案正确
      if (res.length === answerList.length) {
        rightType.value = 1
      }
      // 2 为部分正确
      if (res.length > 0 && res.length < answerList.length) {
        rightType.value = 2
      }
    }

    return {
      values,
      rightType,
      handleInputBlur,
    }
  },
}
</script>

<style lang="scss" scoped>
.choice-title {
  display: inline-block;
}
.mul-wrap {
  display: flex;
  /* align-items: center; */
}
.many_wrap {
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
  border: none;
}
.many-text {
  margin-top: 20px;
  font-size: 34px;
  color: #333;
  line-height: 1.4;

  span.text {
    // display: inline-block;
    // margin-bottom: 10px;
  }
}
.many_item {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-right: 15px;
}
.many_item:last-child {
  margin-right: 0;
}
.many_item > p {
  font-size: 34px;
  color: #333;
  line-height: 1.4;
}
.input_many {
  margin: 10px 5px;
  // width: 190px;
  width: 140px;
  height: 64px;
  font-size: 34px;
  border: 1px solid #e0e0e0;
}
</style>
